/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Component } from "react";
import _ from "lodash";
import Fab from "@material-ui/core/Fab";
import { connect } from "react-redux";
import Model from "../../components/modal";
// import callTune from "../../assets/audios/elegant_sms.mp3";
import { withRouter } from "react-router-dom";
import appRoutes from "../../routes/appRoutes";
import {
  acceptConsultRequest,
  changeDoctorBusyState,
  rejectConsultRequest,
  getBookingDetails,
  endCallByDoctor,
  doctorNotifications
} from "../../apiRoutes";
import {
  doctorOnlineState,
  doctorAppointmentData,
  saveVideoCallData,
  saveSessionId,
  notificationNumber,
  doctorOnlineData,
  setForumReadTopics,
  patientQueueCountData, setTotalDoctors, setForumReadComments
} from "../../reduxStore/actions/commonAction";
import MakeAPICall from "../../apiCalls/common";

import { getSuffixOfNumber } from "../../utils/common";

//connecting to our signaling server
import socket from "../../utils/socket";

import DingBell from "../../assets/audios/ding_for_first_pos.wav";

import APP_CONSTANTS from "../../constants";

const conn = socket;
let connectedUser;
let initiateVideoCall = false;


class SocketHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      socketDisconnectedModel: false, // connection lost - internet
      connectionLostModel: false, // connection lost model for socket - no related to any functionality of video call
      somethingWentWrong: false, // something wentWrong model when doctor is not registed socket Id in backend
      newAppointmentTitle: "", // new appointment title when request a consult from patient
      newAppointmentState: false, // new appointment received model open
      newAppointmentContent: "", // new appointment body content - who requested consult and all (web notificaiton)
      requestedPatientImage: "", // new appointment body content - patient image
      requestedPatientName: "", // new appointment body content - patient name
      requestedNatureOfConsult: "", // new appointment body content - patient requested consult
      consultRequestData: null, // consult request data all - when patient request a consult (new consult web notification data)
      newAppointmentPatientId: null, // patient id storing because getting problem when we get it from other data
      apiCall: null, // for api call
      userData: props.auth && props.auth.userData ? props.auth.userData : null, // getting doctor data from store
      isDoctorOnline: props.commonReducers.doctorOnlineState, // doctor is busy or not ? store data
      // numberinQueue:
      //   props.commonReducers &&
      //   props.commonReducers.doctorOnlineData &&
      //   props.commonReducers.doctorOnlineData.numberinQueue
      //     ? +props.commonReducers.doctorOnlineData.numberinQueue.substr(0, 1)
      //     : null, // doctor's number in the queue
      numberinQueue: null, // doctor's number in the queue
      patientCancelledRequest: null, // this is when patient cancled request before doctor accept it for now this description is correct,
      patientDeviceIssueState: false, // show popup if flag == 6 which means issue with patient device to accept the call
      patientDeviceIssueContent: null, // pop-up body for patient device issue (getting fromm backend)
      doctorTimeOutForAccept: null, // doctor time out for accept request,
      havePatientRequestCancelled: false,

      directCall: false, // default direct call from PMS is false

      socketConnectionTimeout: 0, // socket connection timeout
      socketConnectionError: true, // if socket connection error (We listen to server ping and pong events here in certain interval time)
      doctorSocketId: '', // when doctor connected with socket, we have socket id for that doctor
      isDoctorJoinedSocket: false, // this variable is used to check the doctor is connected to "DOCTORS" channel or not. We can also use this to fire "ONLINE_DOCTORS_SOCKET" as it will count online doctors via socket 
      isDoctorLoggedIn: this.props.isLoggedIn ? true : false, // we will use this to unmount and disconnect socket
    };
    console.log("In socket handler : common reducers ", props.commonReducers);
  }

  componentDidMount() {
    let _this = this;
    initiateVideoCall = false;
    console.log("DOctor Data : ", this.props);
    console.log("Page is loading now");
    console.log("This is temp change");

    console.log(
      "Is doctor online? ",
      this.props.commonReducers.doctorOnlineState
    );

    conn.on("message", msg => {
      console.log("Received message: ", msg);
      let data = "";
      try {
        data = JSON.parse(msg);
      } catch (err) {
        console.log("Data not converted");
        data = msg;
      }
      console.log("Socket handler message: ", data);
      // if (data && data.type === "SERVER_PONG") {
      //   _this.handleServerPong();
      // } else 
      if (data && data.type === "login") {
        _this.handleLogin(data);
        _this.fireOnlineDoctorSocketConnectionEvent();
      }

      // if(
      //   data.data &&
      //   data.data.data &&
      //   _this.state.consultRequestData &&
      //   data.data.data.appointmentId === _this.state.consultRequestData.data.data.appointmentId &&
      //   data.data.from !== "doctor" &&
      //   data.type === "initiateVideoCall" &&
      //   _this.state.directCall === true && data.data.directCall === true
      // ){
      //   console.log("Initiate Video Call From Socket Handler");
      //   this.handleAllMsg(data.data);
      // }else if(
      //   data.data &&
      //   _this.state.consultRequestData &&
      //   data.data.appointmentId === _this.state.consultRequestData.data.data.appointmentId &&
      //   data.data.from !== "doctor" &&
      //   data.type === "initiateVideoCall" &&
      //   _this.state.directCall === true && data.data.directCall === true
      // ){
      //   console.log("Initiate Video Call From Socket Handler");
      //   this.handleAllMsg(data);
      // }

      
      // login and registration error ignore
      // else{
      //   this.handleAllMsg(data);
      // }

    });

    setInterval(() => {
      if (navigator.onLine === false) {
        if (this.props.commonReducers.videoCallData.timerVal > 0) {
          console.log("You are on video call, we can't refresh the page");
        } else {
          this.setState({
            socketDisconnectedModel: true
          });
          setTimeout(() => {
            window.location.reload(true);
          }, 2000);
        }
      }
    }, 1000);

    conn.on("connect", function(data) {
      console.log("Doctor connected ", data);
      _this.setState({
        doctorSocketId: conn.id
      });

      conn.emit('join', "DOCTORS");

      // this is fired because when doctor disconnect or connect, we will update array of online doctors in backend.
      _this.fireOnlineDoctorSocketConnectionEvent();

      //   console.log("Socket id: ", data.id);

      if (_this.props.commonReducers.appointmentData) {
        console.log(
          "@@@@@@@@@@@@@@@@ Sending Video Connect Attempt from socket Handler @@@@@@@@@@@@@@@@@@"
        );
        let dataToSend = {
          type: "videoConnectAttempt",
          appointmentId: _this.props.commonReducers.appointmentData._id,
          from: "doctor"
        };
        console.log("Sending attempt data: ", dataToSend);
        send(dataToSend);
      }

      _this.setState({
        connectionLostModel: false
      });
      if (_this.props.auth && _this.props.auth.userData) {
        let _id = _this.props.auth.userData._id;
        if (_id.length > 0) {
          send({
            type: "login",
            name: _id
          });
        }
      }
    });



    // We will get all the online doctors sorted by last appointments done. It means we get in the order of queue.
    // now you have to match the current doctor position by matching the _id of doctor and set in commonReducers.
    conn.on('DOCTOR_QUEUE_DATA', _this.getDoctorQueuePosition);

    // get the total number of patients count
    conn.on('PATIENTS_IN_QUEUE_COUNT', _this.getPatientQueueCount);

    // this will execute when someone add the new forum post. You will get ignoreUser, means that user id will not have to increase the unread post count from the commonReducers
    conn.on('FORUM_POST_ADDED', _this.increaseForumUnReadCount);

    conn.on("FORUM_COMMENT_ADDED", (data) => {
      if (this.state?.userData?._id !== data.ignoreUser) {
        let unreadComments = this.props.commonReducers.forumReadComments ? +this.props.commonReducers.forumReadComments : 0;
        unreadComments = unreadComments + 1;
        this.props.setForumReadComments(unreadComments);
        console.log({unreadComments})
      }
    });

    // conn.on("IC_SUPPORT", (data) => {
    //   console.log("Message only for support users: ", data);
    // });

    conn.on("disconnect", function() {
      // _this.setState({
      //   connectionLostModel: true
      // });
      _this.setState({
        socketConnectionError: true,
        isDoctorJoinedSocket: false
      });
      console.log(
        "Server disconneted or internet lost, trying to reconnect it until 4 count"
      );
    });

    conn.on("reconnect_attempt", function(data) {
      console.log("Reconnecting to server now: ", data);
      if (data === 4) {
        _this.setState({
          connectionLostModel: true
        });
      }
    });

    conn.on("webNotification", async data => {
      console.log(
        "getting web notification : ",
        data,
        this.state.isDoctorOnline,
        this.state.numberinQueue
      );
      console.log(
        "Conditions : ",
        this.state.userData && this.state.userData._id === data._id
      );
      let flagId = data.data.data.flag;
      if (
        flagId === 14 ||
        flagId === 13 ||
        flagId === 2 ||
        flagId === 30 ||
        flagId === 7 ||
        flagId === 18 ||
        flagId === 28 ||
        flagId === 4
      ) {
        //flagId === 3 || removed because of PMS
        if (
          this.state.userData &&
          this.state.userData._id === data._id &&
          data.data.data.flag === 14
        ) {
          //this.changeDoctorBusyStatusWithCallBack(true, () => {
          //consult request screen
          // this.setState({
          //   consultRequestData: data,
          //   newAppointmentTitle: "Consult Request",
          //   newAppointmentContent: data.data.contents.en,
          //   requestedNatureOfConsult: data.data.data.consultName,
          //   requestedPatientImage:
          //     data.data.data.patientDetails.profilePicture.original,
          //   requestedPatientName: data.data.data.patientDetails.userName,
          //   newAppointmentState: true,
          //   newAppointmentPatientId: data.data.patientId,
          //   havePatientRequestCancelled: false //reset it so that we can use later for detecting cancel from patient queue from admin panel
          // });
          //this.playAudio();
          //this.requestTimeUpForAccepting(); // if doctor don't pickup the consult request within 30 sec then close it
          //});
        } else if (
          data.data.data.flag === 13 &&
          this.state.consultRequestData &&
          data.data.data.appointmentId ===
            this.state.consultRequestData.data.data.appointmentId
        ) {
          // also match appointmentId here
          console.log("Cancelled call by patient");

          // only show this modal when the doctor 5 min timer is not timeout
          if (
            this.props.commonReducers.callTimeoutStatus &&
            this.props.commonReducers.callTimeoutStatus === false
          ) {
            this.setState({
              patientCancelledRequest: true
            });
            this.resetVariableRegardingVideoCall();
          }
        }
        else if (
          data &&
          data._id !== undefined &&
          data.data.data.flag === 2 && data.data.data.directCall === true &&
          this.state.userData._id === data._id
        ) {
          console.log("Patient accepted a call from PMS: ", data);
          //consult request screen
          this.setState({
            consultRequestData: data,
            directCall: true
          });
          initiateVideoCall = false;
          this.changeDoctorBusyStatusWithCallBack(true,  () => {
            const { history } = this.props;
            this.setState({
              newAppointmentState: false
            });
            // this.pauseAudio();
            console.log(
              "Here we will get session id : ",
              data.data.data.sessionId
            );
             this.props.saveSessionId(data.data.data.sessionId);
            console.log(
              "Common Reducers updated with session Id : ",
              this.props.commonReducers
            );
            if (history)
              history.push(appRoutes.callRequestAccepted, {
                callRequestData: this.state.consultRequestData,
                directCall: true,
                acceptedCallByPatient: data.data
              });
          });
        } 
        // else if (
        //   data &&
        //   data._id !== undefined &&
        //   data.data.data.flag === 2 &&
        //   this.state.userData._id === data._id
        // ) {
        //   console.log("Patient accepted a call from PMS");
        //   //consult request screen
        //   this.setState({
        //     consultRequestData: data,
        //     directCall: true
        //   });
        //   initiateVideoCall = false;
        //   this.changeDoctorBusyStatusWithCallBack(true,  () => {
        //     // const { history } = this.props;
        //     this.setState({
        //       newAppointmentState: false
        //     });
        //     // this.pauseAudio();
        //     console.log(
        //       "Here we will get session id : ",
        //       data.data.data.sessionId
        //     );
        //      this.props.saveSessionId(data.data.data.sessionId);
        //     console.log(
        //       "Common Reducers updated with session Id : ",
        //       this.props.commonReducers
        //     );
        //     // if (history)
        //     //   history.push(appRoutes.callRequestAccepted, {
        //     //     callRequestData: this.state.consultRequestData,
        //     //     directCall: true,
        //     //     acceptedCallByPatient: data.data
        //     //   });
        //   });
        // }
        // else if(data.data.data.flag === 3 &&  this.state.userData._id === data._id){ // patient rejected a call when doctor tried to video call patient
        //     console.log("Patient reject a call");
        //     this.setState({
        //       patientCancelledRequest: true
        //     });
        //     // close making a call dialog
        //     // open reject call by patient dialog
        //     // something openT is display none
        // }
        // else if (data && data.data && data.data.data.flag && data.data.data.flag === 4) {
        //   console.log("End call by patient");
        //   console.log("cancelled_call_by_patient_force");
        //   this.resetVariableRegardingVideoCall();
        // }
        // this event occurs when doctor calls patient and patient have not picked up the call
        else if (
          data.data.data.flag === 30 &&
          ((this.state.consultRequestData &&
            data.data.data.appointmentId ===
              this.state.consultRequestData.data.data.appointmentId) ||
            this.state.userData._id === data._id) &&
          data.data.data.directCall !== true
        ) {
          // issue with the patient device - patient didn't accept the call
          console.log("Missed call by patient");
          // changing here - 22 Oct 2020 = Commenting below popup
          // this.handlePatientCallNoPickup(data);
          //this.resetVariableRegardingVideoCall();

          // timer flase
          // 2 conditions - patient side have issue & patient side have issue from myappointment
        } else if (
          data.data.data.flag === 7 &&
          this.state.userData._id === data._id
        ) {
          console.log("Connection error, try again ");
          //this.resetVariableRegardingVideoCall();
        } else if (
          data.data.data.flag === 18 &&
          (this.state.userData._id === data._id || this.state.userData._id === data.data.data.doctorId)
        ) {
          console.log("ReloadState broadcast");
          this.getAllNotifications();
        }
        // if admin removes the patient from the queue
        else if (
          data.data.data.flag === 28 &&
          this.state.consultRequestData !== null &&
          data.data.data.appointmentId ===
            this.state.consultRequestData.data.data.appointmentId
        ) {
          this.handlePatientQueueRemovalUsecase(data);
        } else {
          if (
            data &&
            data._id &&
            data.data &&
            data.data.data.flag &&
            data.data.data.flag === 4 &&
            this.state.userData._id === data._id
          ) {
            console.log("End call by patient");
            console.log("cancelled_call_by_patient_force");
            this.resetVariableRegardingVideoCall();
          }
        }
        // else if(data.data.data.flag === 20){ // add data.data.data.endCall == "doctor in condition"
        //     console.log("Disconnected doctor call");
        //     this.props.doctorAppointmentData(null);
        // }
        // else if(data.data.data.flag  === 13 && event.data.appointmentId == $scope.appointmentId)
      }

      // // admin sent ticket notification
      // if(flagId === 18){
      //   if( this.state.userData &&
      //     this.state.userData._id === data._id){
      //       this.getAllNotifications();
      //     }
      // }
    });

    this.checkSocketConnection();

    // setInterval(() => {
    //   this.checkSocketConnection();
    // }, 30000);
  };

  componentWillUnmount() {
    console.log("Component will unmount - Socket handler");
    socket.disconnect();
    this.setState({
      isDoctorLoggedIn: false
    });
  }

  // checkSocketConnection() {
  //   const loggedInUserData = this.props.auth && this.props.auth.userData ? this.props.auth.userData : null;
  //   const isUserLoggedIn = this.props.isLoggedIn;
  //   // console.log("----- checkSocketConnection ------ ", isUserLoggedIn, loggedInUserData);
  //   setTimeout(() => {
  //     conn.emit("serverping", socket.id);
  //   }, 2000);
  //   setInterval(() => {
  //     console.log("** Check Socket Connection **");
  //     console.log("Is socket connected? isUserLoggedIn? loggedInUserData", conn.connected, isUserLoggedIn, loggedInUserData, !conn.connected && loggedInUserData && isUserLoggedIn);
  //     conn.emit("serverping", socket.id);
  //     if (!conn.connected && loggedInUserData && isUserLoggedIn) {
  //       socket.connect();
  //       this.setState({
  //         socketConnectionError: true
  //       });
  //     } else {
  //       console.log("Disconnecting doctor because not authorised");
  //       socket.disconnect();
  //     }
  //   }, APP_CONTANTS.SOCKET_PING_PONG_INTERVAL);
  // }

  checkSocketConnection() {
    const loggedInUserData = this.props.auth && this.props.auth.userData ? this.props.auth.userData : null;
    const isUserLoggedIn = this.state.isDoctorLoggedIn;
    console.log("checkSocketConnection: isSocketNotConnected? isUserLoggedIn? userLoggedInData? ", !conn.connected && loggedInUserData && isUserLoggedIn, !conn.connected, isUserLoggedIn, loggedInUserData);
    if (!conn.connected && loggedInUserData && isUserLoggedIn) {
      console.log("User is logged in but socket is not connected");
      socket.connect();
      this.setState({
        socketConnectionError: true
      });
    } else if (!conn.connected && !isUserLoggedIn) {
      console.log("Disconnecting doctor because not authorised");
      socket.disconnect();
    } else if (conn.connected && !this.state.isDoctorJoinedSocket && isUserLoggedIn) {
      this.fireOnlineDoctorSocketConnectionEvent();
      conn.emit('join', "DOCTORS");
      this.setState({
        isDoctorJoinedSocket: true
      });
    }
  }

  // handleServerPong() {
  //   console.log("Handle server pong");
  //   clearTimeout(this.state.socketConnectionTimeout);
  //   this.setState({
  //     socketConnectionError: false
  //   });
  //   this.setState({
  //     socketConnectionTimeout: setTimeout(() => {
  //       this.setState({
  //         socketConnectionError: true
  //       })
  //     }, APP_CONTANTS.SOCKET_PING_PONG_INTERVAL)
  //   });
  // }

  fireOnlineDoctorSocketConnectionEvent() {
    const loggedInUserData = this.props.auth && this.props.auth.userData ? this.props.auth.userData : null;
    const isUserLoggedIn = this.state.isDoctorLoggedIn;
    if (conn.connected && isUserLoggedIn && loggedInUserData) {
      const dataToSendForOnlineDoctorSocket = {
        socketId: socket.id,
        doctor_id: loggedInUserData._id,
        doctorId: loggedInUserData.doctorId,
        doctorName: `Dr. ${loggedInUserData.firstName} ${loggedInUserData.lastName}`,
        isMac: /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)
      }
      console.log("ONLINE_DOCTORS_SOCKET - fired");
      socket.emit("ONLINE_DOCTORS_SOCKET", dataToSendForOnlineDoctorSocket);
    }
  }

  getAllNotifications = () => {
    let apiCallParam = {
      reqType: "GET",
      reqURL: doctorNotifications,
      dataObj: {},
      params: {
        limit: 0,
        skip: 0
      },
      headers: {},
      successCallback: async res => {
        await this.props.notificationNumber({"totalNotification":res.data.data.unReadCount});
      },
      failureCallback: err => {
        //console.log("Error API Call : ", err);
      },
      showPopUp: false
    };
    this.setState({ apiCall: apiCallParam });
  };

  handleAllMsg = data => {
    console.log("Data got to handle with socket : ", data);

    switch (data.type) {
      // case "login":
      //   this.handleLogin(data.success);
      //   break;

      case "registrationError":
        console.log("Socket ID Registration error");
        this.setState({
          somethingWentWrong: true
        });
        break;
      // case "initiateVideoCall":
      //    console.log("Initiate Video Call Event Check: ", initiateVideoCall);
      //     if(initiateVideoCall === false){
      //       initiateVideoCall = true;
      //       this.goToConsultDetailPageWithDirectCall(data);
      //     }
      //     break;
      default:
        console.log("Nothing matched");
        break;
    }
  };

  goToConsultDetailPageWithDirectCall = (data) => {
    const { history } = this.props;
    console.log("setting this data: ** Here ** ", data);
    if (history){
      initiateVideoCall = false;
      history.push(appRoutes.callRequestAccepted, {
        callRequestData: this.state.consultRequestData,
        directCall: true,
        acceptedCallByPatient: data
      });
    }
  }

  handleLogin = loginData => {
    // console.log("Socket update here : ", loginData);
    this.setState({
      socketConnectionError: false
    });
  };

  // pauseAudio = () => {
  //   const audioEl = document.getElementsByClassName("callAudioDoctor")[0];
  //   audioEl.pause();
  // };

  // playAudio = () => {
  //   try {
  //     const audioEl = document.getElementsByClassName("callAudioDoctor")[0];
  //     audioEl.play();
  //   } catch (e) {
  //     console.log("Audio Direct Play Not Allowed By System CatchBlock: ", e);
  //   }
  // };

  // handle missed call by patient
  handlePatientCallNoPickup = data => {
    this.setState({
      patientDeviceIssueContent:
        "Video call connection unsuccessful<br/>Please attempt to phone call the patient", //data.data.contents.en,
      patientDeviceIssueState: true
    });

    // cancel the appointment with missed call status if patient does not picked up the call
    //this.patientMissedCall();

    // this.changeDoctorBusyStatusWithCallBack(true, () => {});
  };

  // if patient removes from the queue from admin end
  handlePatientQueueRemovalUsecase = () => {
    this.setState({
      havePatientRequestCancelled: false
    });

    // if the doctor is receiving the patient consult request popup
    if (this.state.newAppointmentState === true) {
      // clear the popup timeout since we have already closed the popup
      clearTimeout(this.state.doctorTimeOutForAccept);

      this.setState({
        newAppointmentState: false,
        doctorTimeOutForAccept: null,
        havePatientRequestCancelled: true
      });

      // this.pauseAudio();

      // update doctor status and go to dashboard
      this.changeDoctorBusyStatusWithCallBack(false, () => {
        this.resetVariableRegardingVideoCall();
        this.gotToDashboard();
      });
    }
  };

  // check if appointment is cancelled by patient or not
  checkIfAppointmentStillValid = (isRejected, callback) => {
    let apiCallParam = {
      reqType: "GET",
      reqURL: getBookingDetails,
      params: {
        booking_id: this.state.consultRequestData.data.data.appointmentId
      },
      headers: {},
      successCallback: async res => {
        // patient have cancelled the consult request
        if (
          (res.data.data.status === 10 ||
            res.data.data.status === 2 ||
            res.data.data.status === 3 ||
            res.data.data.status === 4) &&
          isRejected === false
        ) {
          this.setState({
            newAppointmentState: false,
            patientCancelledRequest: true
          });
          this.resetVariableRegardingVideoCall();
        } else if (res.data.data.status === 10 && isRejected === true) {
          this.handlePatientQueueRemovalUsecase();
        } else {
          // proceed if everything is alright
          callback();
          // setTimeout(() => {
          //   callback();
          // }, 280);
        }
      },
      failureCallback: err => {
        this.handlePatientQueueRemovalUsecase();
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParam
    });
  };

  // accept button click event
  acceptConsultRequest = () => {
    // this.pauseAudio();
    clearTimeout(this.state.doctorTimeOutForAccept);
    // we will first verify whether the patient have cancelled their consult request or not
    this.checkIfAppointmentStillValid(false, this.acceptConsultRequestStep2);
  };

  acceptConsultRequestStep2 = () => {
    console.log(
      "NOw accepting consult request : ",
      this.state.consultRequestData
    );
    clearTimeout(this.state.doctorTimeOutForAccept);
    let bodyData = new FormData();
    bodyData.append("doctorId", this.state.userData._id);
    bodyData.append(
      "patientId",
      this.state.consultRequestData.data.data.patientId
    );
    bodyData.append(
      "appointmentId",
      this.state.consultRequestData.data.data.appointmentId
    );
    let apiCallParam = {
      reqType: "PUT",
      reqURL: acceptConsultRequest,
      dataObj: bodyData,
      params: {},
      headers: {},
      successCallback: res => {
        console.log("Call appeted request done : ", res.data);
        this.changeDoctorBusyStatusWithCallBack(true, () => {
          const { history } = this.props;
          this.setState({
            newAppointmentState: false
          });
          // this.pauseAudio();
          console.log("Common Reducers updated : ", this.props.commonReducers);
          if (history) {
              history.push(appRoutes.callRequestAccepted, {
                callRequestData: this.state.consultRequestData
              });
            // setTimeout(()=> {
            //   history.push(appRoutes.callRequestAccepted, {
            //     callRequestData: this.state.consultRequestData
            //   });
            // }, 280);
          }
        });
      },
      failureCallback: err => {
        this.setState({
          newAppointmentState: false
        });
        console.log("Something went wrong. Please try again ", err);
        this.changeDoctorBusyStatusWithCallBack(false, () => {
          this.resetVariableRegardingVideoCall();
          this.gotToDashboard();
        });
      },
      showPopUp: false
    };
    //   props.makeAPICall(apiCallParam);
    this.setState({
      apiCall: apiCallParam
    });
  };

  // rejecting new consult request - reject button clicked
  rejectConsultRequest = () => {
    // this.pauseAudio();
    clearTimeout(this.state.doctorTimeOutForAccept);

    // only call thsi when the consult request is not cancelled otherwise it will messed up the appointment state as it puts the apoointment into the queue again by updating its status
    // we will first verify whether the patient have cancelled their consult request or not
    this.checkIfAppointmentStillValid(true, this.rejectConsultRequestPart2);
  };

  rejectConsultRequestPart2 = () => {
    this.setState({
      newAppointmentState: false
    });

    console.log(
      "Reject consult Data here: ###  ",
      this.state.consultRequestData
    );
    let patientId =
      this.state.consultRequestData && this.state.consultRequestData.data.data
        ? this.state.consultRequestData.data.data.patientId
        : this.state.newAppointmentPatientId;
    // this.pauseAudio();
    let bodyData = new FormData();
    bodyData.append("doctorId", this.state.userData._id);
    bodyData.append("patientId", patientId);
    bodyData.append(
      "appointmentId",
      this.state.consultRequestData.data.data.appointmentId
    );

    let apiCallParamDoctorState = {
      reqType: "PUT",
      reqURL: rejectConsultRequest,
      dataObj: bodyData,
      params: {},
      headers: {},
      successCallback: async res => {
        this.resetVariableRegardingVideoCall();
        this.gotToDashboard();
        // we are putting delay here so that in case of reject request from doctor it can be forwarded to the next doctor in queue [Ali] - Now I [vatsaly] changed it - no more delay
        // setTimeout(() => {
        this.changeDoctorBusyStatusWithCallBack(false, () => {});
        // }, 7000);
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again : ", err);
        this.resetVariableRegardingVideoCall();
        this.gotToDashboard();
        setTimeout(() => {
          this.changeDoctorBusyStatusWithCallBack(false, () => {});
        }, 7000);
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParamDoctorState
    });
  };

  // change doctor busy state with callback
  changeDoctorBusyStatusWithCallBack = (changeState, callback) => {
    let bodyDataDoctorState = new FormData();
    bodyDataDoctorState.append("isBusy", changeState);
    let apiCallParamDoctorState = {
      reqType: "PUT",
      reqURL: changeDoctorBusyState,
      dataObj: bodyDataDoctorState,
      params: {},
      headers: {},
      successCallback: async res => {
        callback();
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again : ", err);
        callback();
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParamDoctorState
    });
  };

  // patient cancelleted call from queue - go to dashboard
  patientCancelltedRequestFromQueue = () => {
    this.setState({
      patientCancelledRequest: false
    });
    this.changeDoctorBusyStatusWithCallBack(false, () => {
      this.gotToDashboard();
    });
  };

  // cancel the appointment with missed call status if doctor calls the patient and no one picks up
  patientMissedCall = () => {
    console.log(
      "------------------------- Testing Patient Missed Call Appointment Data ------------------"
    );
    console.log(
      "------------------------- Testing Patient Missed Call Appointment Data ------------------"
    );
    console.log(
      "------------------------- Testing Patient Missed Call Appointment Data ------------------"
    );
    console.log(
      "ConsultRequestData: ",
      this.state.consultRequestData.data.data.appointmentId
    );
    console.log(
      "Common Reducers data: ",
      this.props.commonReducers.appointmentData._id
    );

    let data = new FormData();

    if (
      this.props.commonReducers.appointmentData &&
      this.props.commonReducers.appointmentData._id
    ) {
      data.append(
        "appointmentId",
        this.props.commonReducers.appointmentData._id
      );
    } else {
      data.append(
        "appointmentId",
        this.state.consultRequestData.data.data.appointmentId
      );
    }

    let sessionId = this.props.commonReducers.sessionId
      ? this.props.commonReducers.sessionId
      : "";

    data.append("sessionId", sessionId);
    data.append("callStatus", "MISSED");

    let apiCallParam = {
      reqType: "PUT",
      reqURL: endCallByDoctor,
      dataObj: data,
      params: {},
      headers: {},
      successCallback: res => {},
      failureCallback: err => {},
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParam
    });
  };

  gotToDashboard = () => {
    const { history } = this.props;
    if (history) history.push(appRoutes.dashboard);
  };

  patientDeviceIssue = () => {
    this.setState({
      patientDeviceIssueState: false
    });
    // this.changeDoctorBusyStatusWithCallBack(false, () => {
    //   this.resetVariableRegardingVideoCall();
    //   this.gotToDashboard();
    // });
  };

  // Patient request arrives on doctor side and if doctor don't accept it then do this
  requestTimeUpForAccepting = () => {
    this.setState({
      doctorTimeOutForAccept: setTimeout(() => {
        // this.pauseAudio();
        if (
          this.props.commonReducers.doctorOnlineState === true &&
          this.state.havePatientRequestCancelled !== true // only run this when patient have not cancelled their consult request
        ) {
          this.rejectConsultRequest();
        }
      }, 28000)
    });
  };

  resetVariableRegardingVideoCall = () => {
    this.props.doctorAppointmentData(null);
    initiateVideoCall = false;
    this.props.saveVideoCallData({
      isCallAccepted: false,
      timerVal: 0,
      directCall: false,
      consultRequestData: null
    });
  };

  // update doctor queue position data
  // 1. We will check the current doctor id with the array got in broadcastData. If the index matches then that's the current doctor queue number
  // once you found the queue number then store into redux so we can use it on other components. Mostly usage on Sidebar component.

  getDoctorQueuePosition = async (broadcastData) => {
    console.log("Doctor Queue Broadcast: ", broadcastData);
    if (this.state.userData && this.state.userData._id) {
      // * currentDocPosition gives you the position from the array and which starts from zero, so we need to increase a number for front-end
      let currentDocPosition = _.findIndex(broadcastData, (o) => {
        return o._id == this.state.userData._id // we have Object Id, so we need to convert it to string and then match
      });

      console.log("Current Doc Position: ", currentDocPosition);

      if (currentDocPosition !== -1) {
        currentDocPosition++; // to display 1st, 2nd, ... on front-end we increse the number because arrays start from 0 position
        currentDocPosition = getSuffixOfNumber(currentDocPosition);
      }
      let data = {
        totalConsults: this.props.commonReducers.doctorOnlineData.totalConsults || 0,
        numberinQueue: currentDocPosition,
        // totalDoctor: broadcastData.length,
        totalPatient: this.props.commonReducers.doctorOnlineData.totalPatient || 0,
        totalNotifications: this.props.commonReducers.doctorOnlineData.totalNotifications || 0,
        waitTime: this.props.commonReducers.doctorOnlineData.waitTime || 0,
        waitCount: this.props.commonReducers.doctorOnlineData.waitCount || 0,
        newForumPostsCount: this.props.commonReducers.doctorOnlineData.newForumPostsCount || 0
      };
      await this.props.doctorOnlineData(data);

      console.log("Doctor's current position: ", currentDocPosition);
      console.log("Patients Queue Count: ", this.props.commonReducers.patientsQueueCount);
      if (currentDocPosition === "1st" && (this.props.commonReducers && this.props.commonReducers.patientsQueueCount > 0)) {
        console.log("You have to ring the bell");
        this.playDingAudio();
      } else {
        this.pauseDingAudio();
      }
    }
  }

  getPatientQueueCount = async (broadcastData) => {
    console.log("I'm getting patient queue count: ", broadcastData);
    this.props.patientQueueCountData(broadcastData.count);
    this.props.setTotalDoctors(broadcastData.onlineDoctors);
  }

  increaseForumUnReadCount = async (boradCastData) => {
    if (this.state.userData && this.state.userData._id && boradCastData.ignoreUser !== this.state.userData._id) {
      let currentUnreadPostCount = this.props.commonReducers.forumReadTopics ? +this.props.commonReducers.forumReadTopics : 0;
      currentUnreadPostCount = currentUnreadPostCount + 1;
      await this.props.setForumReadTopics(currentUnreadPostCount);
    }
  }

  playDingAudio() {
    try {
      const audioEl = document.getElementsByClassName("ding-bell-patient-queue")[0];
      audioEl.play();
    } catch (e) {
      console.log("Ding-Bell Audio Direct Play Not Allowed By System CatchBlock: ", e);
    }
  }

  pauseDingAudio() {
    try {
      const audioEl = document.getElementsByClassName("ding-bell-patient-queue")[0];
      audioEl.pause();
    } catch (e) {
      console.log("Ding-Bell Audio Direct Play Not Allowed By System CatchBlock: ", e);
    }
  }

  render() {
    return (
      <div className="socket-handler">
        {/* Connection Lost Model */}
        <Model
          openModal={this.state.connectionLostModel}
          modalBodyContent="Waiting for connection to server. <br/> Ensure you are connected to the internet. <br/> Please contact Instant Consult Support <br/> on 1300 003 310 if this issue persists."
          okayText="Okay"
          cancelText="Okay"
          title="Connection Lost"
          useOneButton={true}
          okayEvent={() => console.log("Clicked")}
          cancelEvent={() => console.log("Cancel clicked")}
          backdrop="static"
        />

        {/* Some error occured at backend, please check for your reference */}
        <Model
          openModal={this.state.somethingWentWrong}
          modalBodyContent="Something Went Wrong, Please refresh the browser"
          okayText="Okay"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          okayEvent={() => console.log("Clicked")}
          cancelEvent={() => console.log("Cancel clicked")}
          backdrop="static"
        />

        {/* Got the new appointment */}
        <Model
          openModal={this.state.newAppointmentState}
          modalBodyContent={`
                        <div class="row p-0 m-0">
                            <div class="col-sm-12 text-center">
                                <p class="text-center mb-3">You have a new Consult Request from </p>
                            </div>
                            <div class="col-sm-3">
                                <img src="${this.state.requestedPatientImage}" alt="patient-img" class="requested-user-profile-pic" />
                            </div>
                            <div class="col-sm-9 pt-4 pl-5">
                                <p class="requested-patient-name text-left secondary-font mb-0 requested-user-name">${this.state.requestedPatientName}</p>
                                <p class="requested-patient-name text-left requested-user-consult-request">Nature of Consult: ${this.state.requestedNatureOfConsult}</p>
                            </div>
                        </div>
                    `}
          okayText="Accept"
          cancelText="Reject"
          title={this.state.newAppointmentTitle}
          useOneButton={false}
          okayEvent={this.acceptConsultRequest}
          cancelEvent={this.rejectConsultRequest}
          backdrop="static"
        />

        <Fab
          size="medium"
          color="secondary"
          aria-label="socket-connection"
          className={this.state.socketConnectionError && this.props.isLoggedIn ? "socket-connection-fab" : "d-none"}
        >
          <i class="fas fa-exclamation"></i>
        </Fab>

        {/* Patient cancled request from queue - before doctor called patient */}
        <Model
          openModal={this.state.patientCancelledRequest}
          modalBodyContent="Patient has cancelled their <br/> Consult Request"
          okayText="Okay"
          cancelText="Okay"
          title="Consult Cancelled"
          useOneButton={true}
          okayEvent={this.patientCancelltedRequestFromQueue}
          cancelEvent={this.patientCancelltedRequestFromQueue}
          backdrop="static"
        />

        {/* Device issue with patient device */}
        <Model
          openModal={this.state.patientDeviceIssueState}
          modalBodyContent={this.state.patientDeviceIssueContent}
          okayText="Okay"
          cancelText="Okay"
          title="Patient Device Issue"
          useOneButton={true}
          okayEvent={this.patientDeviceIssue}
          cancelEvent={this.patientDeviceIssue}
          backdrop="static"
        />

        {/* You are disconnected, please refresh the page */}
        <Model
          openModal={this.state.socketDisconnectedModel}
          modalBodyContent="Network Connection Updated"
          okayText="Okay"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          noButtons={true}
          okayEvent={() => window.location.reload(true)}
          cancelEvent={() => window.location.reload(true)}
          backdrop="static"
        />

        {/* <audio className="callAudioDoctor d-none" loop>
          <source src={callTune}></source>
        </audio> */}

        <audio className="ding-bell-patient-queue d-none">
          <source src={DingBell}></source>
        </audio>

        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />
      </div>
    );
  }
}

// export default SocketHandler;

// // get the store
const mapStateToProps = props => ({
  auth: props.auth.user,
  isLoggedIn: props.auth.isLoggedIn,
  commonReducers: props.commonReducers
});

const mapDispatchToProps = dispatch => ({
  doctorOnlineData: data => dispatch(doctorOnlineData(data)),
  patientQueueCountData: data => dispatch(patientQueueCountData(data)),
  doctorOnlineState: data => dispatch(doctorOnlineState(data)),
  doctorAppointmentData: data => dispatch(doctorAppointmentData(data)),
  saveVideoCallData: data => dispatch(saveVideoCallData(data)),
  saveSessionId: data => dispatch(saveSessionId(data)),
  notificationNumber: (data) => dispatch(notificationNumber(data)),
  setForumReadTopics: data => dispatch(setForumReadTopics(data)),
  setForumReadComments: data => dispatch(setForumReadComments(data)),
  setTotalDoctors: data => dispatch(setTotalDoctors(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SocketHandler));

function send(message) {
  //attach the other peer username to our messages
  if (connectedUser) {
    message.name = connectedUser;
  }
  conn.send(JSON.stringify(message));
}

/* ************************ Extra code **** Not Needed For now **** But Keeping it********  */

// Change doctor busy state
//  changeDoctorBusyStatus = () => {
//     let bodyDataDoctorState = new FormData();
//     bodyDataDoctorState.append('isBusy', true);
//     let apiCallParamDoctorState = {
//         reqType: "PUT",
//         reqURL: changeDoctorBusyState,
//         dataObj: bodyDataDoctorState,
//         params: {},
//         headers: {},
//         successCallback:async res => {
//             console.log("Doctor busy state changed : ", res.data);
//             this.props.commonReducers.doctorOnlineState = false;
//             const { history } = this.props;
//             this.setState({
//                 newAppointmentState: false
//             });
//             this.pauseAudio();
//             console.log("Common Reducers updated : ", this.props.commonReducers);
//             if (history) history.push(appRoutes.callRequestAccepted, { callRequestData: this.state.consultRequestData });
//         },
//         failureCallback: err => {
//             console.log("Something went wrong. Please try again : ", err);
//         },
//         showPopUp: false
//     };
//     this.setState({
//         apiCall: apiCallParamDoctorState
//     });
// };
